import React, { useEffect, useState, useCallback } from "react";
import { Box, useMediaQuery, Typography, Link, Button } from "@mui/material";
import MyTasksTable from "../MyTasksTable/MyTasksTable";
import MyTasksResponsive from "../MyTasksResponsive/MyTasksResponsive";
import { MyTasksStyles } from "./MyTasksStyles";
import listIcon from "../../assets/svgs/list-view-icon.svg";
import listWhiteIcon from "../../assets/svgs/list-view-white-icon.svg";
import calenderIcon from "../../assets/svgs/calender-view-icon.svg";
import calenderWhiteIcon from "../../assets/svgs/calender-view-white-icon.svg";
import HeadingText from "../../common/HeadingText/HeadingText";
import ImageAndText from "../ImageAndText/ImageAndText";
import filterIcon from "../../assets/svgs/filter-icon.svg";
import TabSwitch from "../../common/TabSwitch/TabSwitch";
import { tasksTableHeadingsData } from "../../constants/tasksData";
import { FILTER, MY_TASKS, TAB1, TAB2 } from "../../constants";
import FullCalendarComponent from "../MyTasksCalendar/MyTasksCalendar";
import { calenderData } from "../../constants/CalenderData";
import FilterPopUp from "../FilterPopUp/FilterPopUp";
import { filterPopUpStatusOptions } from "../../constants/FilterPopUpCommonOptions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { GetAgentTasks } from "./MyTasksAction";
import { getCookie } from "../../utils/Utility";
import {
  IAgentTask,
  IAgentTasksRequestBody,
} from "../../models/agent/policiesListing";
import { MomentInput } from "moment";
import moment from "moment";
import EmptyScreen from "../EmptyScreen/EmptyScreen";
import { useNavigate, useSearchParams } from "react-router-dom";
import ModalComponent from "../../common/ModalComponent/ModalComponent";
import { MyTasksCalendarStyles } from "../MyTasksCalendar/MyTasksCalendarStyles";
import MyTasksCalendarCard from "../MyTasksCalendarCard/MyTasksCalendarCard";
import AddTaskForm from "../AddTaskForm/AddTaskForm";
import { EditAddTask } from "../AddTaskForm/AddTaskActions";
import DashboardBreadCrumb from "../DashboardBreadCrumb/DashboardBreadCrumb";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { DeleteAgentTask } from "./MyTasksAction";
import { RootState } from "../../store/store";

const MyTasks: React.FC = () => {
  const providerId = getCookie("id");
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("id");

  const { editTaskResponse, addTaskResponse } = useAppSelector(
    (state) => state.addTask
  );
  const isSmallScreen = useMediaQuery("(max-width: 1023px)");
  const [activeTab, setActiveTab] = useState(TAB1);
  const [isSlide, setIsSlide] = useState(false);
  const [selectedKey, setSelectedKey] = useState(
    filterPopUpStatusOptions[0].key
  );
  const [isEditTask, setIsEditTask] = useState<boolean>(false);
  const [isRescheduleTask, setIsRescheduleTask] = useState<boolean>(false);
  const [openTaskDialog, setOpenTaskDialog] = useState<boolean>(false);
  const [modalData, setModalData] = useState<IAgentTask | null>(null);
  const [deleteTaskDialogOpen, setDeleteTaskDialogOpen] = useState<boolean>(false);
  const [taskToDelete, setTaskToDelete] = useState<IAgentTask | null>(null);
  const { calledReducerType, isLoading, isSuccess, isError } = useAppSelector((state) => state.common);
  const navigate = useNavigate();

  const Fillter = (): string => {
    if (selectedKey === "0") {
      return "ALL";
    } else if (selectedKey === "1") {
      return "Open";
    } else if (selectedKey === "2") {
      return "Completed";
    } else if (selectedKey === "3") {
      return "Overdue";
    }
    return "";
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setIsSlide(tab === TAB2);
  };
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (key: string) => {
    setSelectedKey(key);
    handleClose();
  };
  const tasksData = calenderData.flatMap((calendar) =>
    calendar.meetings.map((meeting) => meeting.taskDetails)
  );

  const compareAsc = (date1: MomentInput, date2: MomentInput) => {
    if (moment(date1).isBefore(date2)) return -1;
    if (moment(date1).isAfter(date2)) return 1;
    return 0; // dates are the same
  };

  const { data } = useAppSelector((state) => state.agentTasks);

  // Step 2: Add priority and filter tasks
  const processedTasks = data
    .map((task) => ({
      ...task,
      // status: "Active",
    }))
    .sort((a, b) => {
      // Define PriorityKey type
      type PriorityKey = "high" | "medium" | "low" | "none";

      // Define the priorityOrder with numeric values
      const priorityOrder: Record<PriorityKey, number> = {
        high: 1,
        medium: 2,
        low: 3,
        none: 4,
      };

      // Compare priorities numerically
      const priorityDiff =
        priorityOrder[a.priority?.toLowerCase() as PriorityKey] -
        priorityOrder[b.priority?.toLowerCase() as PriorityKey];
      if (priorityDiff !== 0) return priorityDiff;

      // If priorities are the same, compare dates
      return compareAsc(new Date(a.dueDate), new Date(b.dueDate));
    });

  const handleModalClose = () => {
    setOpenTaskDialog(false);
    setModalData(null);
  };

  const handleEditTask = () => {
    setOpenTaskDialog(false);
    setIsEditTask(true);
  };
  const handleRescheduleTask = () => {
    setOpenTaskDialog(false);
    setIsRescheduleTask(true);
  };
  const handleMarkAsComplete = () => {
    if (modalData) {
      const requestBody = {
        ...modalData,
        status: modalData.status === "Open" ? "Completed" : "Open",
      };
      dispatch(EditAddTask(requestBody));
    }
    handleModalClose();
  };

  const handleDeleteTask = () => {
    if (modalData) {
      // Verify that required id is present
      if (!modalData.id) {
        // Missing required fields; do not proceed
        return;
      }
      
      setTaskToDelete(modalData);
      setDeleteTaskDialogOpen(true);
      setOpenTaskDialog(false);
    }
  };

  const handleDeleteTaskConfirm = () => {
    if (taskToDelete) {
      // Double-check that id is present
      if (!taskToDelete.id) {
        return;
      }
      
      dispatch(
        DeleteAgentTask(taskToDelete.id)
      );
      setDeleteTaskDialogOpen(false);
      setTaskToDelete(null);
    }
  };

  const handleDeleteTaskCancel = () => {
    setDeleteTaskDialogOpen(false);
    setTaskToDelete(null);
  };

  const handleNavigateToPolicy = useCallback(() => {
    if (!taskId) return;

    const currentTask = processedTasks.find((task) => task.id === taskId);
    if (!currentTask) return;
    navigate(
      `/agent/policyDetails/${currentTask.policyId}/${currentTask.carrier}/${currentTask.system}/${currentTask.lobCode}/${currentTask.customerId}`
    );
  }, [taskId, processedTasks, navigate]);

  useEffect(() => {
    const requestParams: IAgentTasksRequestBody = {
      providerId,
    };
    dispatch(GetAgentTasks(requestParams));
  }, [dispatch, editTaskResponse, addTaskResponse]);

  useEffect(() => {
    if (editTaskResponse) {
      setIsEditTask(false);
      setIsRescheduleTask(false);
    }
  }, [editTaskResponse]);

  // Handle successful task deletion
  useEffect(() => {
    if (isSuccess && calledReducerType === "agent/delete-task") {
      // Refresh the tasks list after successful deletion
      const requestParams: IAgentTasksRequestBody = {
        providerId,
      };
      dispatch(GetAgentTasks(requestParams));
    }
  }, [isSuccess, calledReducerType, dispatch, providerId]);

  // Apply filter based on selectedKey
  const filteredTasks = processedTasks.filter((task) => {
    if (taskId && task.id !== taskId) {
      return false; // Always filter by taskId if present
    }

    const selectedFilter = Fillter();
    if (selectedFilter === "ALL") {
      return true; // Show all tasks
    }

    const taskStatus = task.status?.toLowerCase();
    const today = moment().startOf("day");
    const dueDate = moment(task.dueDate).startOf("day");

    if (selectedFilter === "Open") {
      // "Open" means not "Completed" and not "Overdue"
      return taskStatus !== "completed";
    }

    if (selectedFilter === "Completed") {
      return taskStatus === "completed";
    }

    if (selectedFilter === "Overdue") {
      // "Overdue" means the due date is in the past and status is not "Completed"
      return dueDate.isBefore(today) && taskStatus !== "completed";
    }

    return true; // Default to showing all if filter logic is unclear
  });

  return (
    <>
      <Box sx={MyTasksStyles.container}>
        <Box sx={MyTasksStyles.headerContainer}>
          <Box sx={MyTasksStyles.headingFilterContainer}>
            <Box sx={MyTasksStyles.backButtonContainer}>
              {!!taskId && (
                <Link
                  component="button"
                  onClick={handleNavigateToPolicy}
                  sx={MyTasksStyles.backButton}
                >
                  <KeyboardArrowLeftIcon />
                </Link>
              )}
              <HeadingText heading={MY_TASKS} />
            </Box>
            {isSmallScreen && activeTab === TAB2 && (
              <ImageAndText
                additionalClassName={MyTasksStyles.imageAndTextHeadingContainer}
                image={filterIcon}
                text={FILTER}
                onhandleClick={handleClick}
              />
            )}
          </Box>
          <Box sx={MyTasksStyles.imageContainer}>
            <ImageAndText
              additionalClassName={MyTasksStyles.imageAndTextContainer}
              image={filterIcon}
              text={Fillter()}
              onhandleClick={handleClick}
            />

            <TabSwitch
              tab1Title={isSmallScreen ? "List" : "List View"}
              tab2Title={isSmallScreen ? "Calendar" : "Calendar View"}
              tab1ActiveImage={listWhiteIcon}
              tab2ActiveImage={calenderWhiteIcon}
              tab2InActiveImage={calenderIcon}
              tab1InActiveImage={listIcon}
              handleTabClick={handleTabChange}
              activeTab={activeTab}
              isSlide={isSlide}
              tab2AdditionalStyles={MyTasksStyles.tab2AdditionalStyles}
              tab1AdditionalStyles={MyTasksStyles.tab1AdditionalStyles}
            />
          </Box>
        </Box>
        {activeTab === TAB1 ? (
          filteredTasks?.length > 0 ? (
            isSmallScreen ? (
              <MyTasksResponsive tasksData={filteredTasks} />
            ) : (
              <MyTasksTable
                tasksData={filteredTasks}
                activeTab={activeTab}
                tasksTableHeadingsData={tasksTableHeadingsData}
                selectedKey={selectedKey}
                isEditTask={isEditTask}
                setOpenTaskDialog={setOpenTaskDialog}
                setModalData={setModalData}
              />
            )
          ) : (!isLoading && isSuccess) || (!isLoading && isError) ? (
            <>
              <EmptyScreen />
            </>
          ) : (
            <></>
          )
        ) : (
          <FullCalendarComponent
            dayWiseEvents={filteredTasks}
            setOpenTaskDialog={setOpenTaskDialog}
            setTaskModalData={setModalData}
          />
        )}
      </Box>
      <FilterPopUp
        options={filterPopUpStatusOptions}
        selectedKey={selectedKey}
        onSelect={handleSelect}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
      <ModalComponent
        heading={"Task Details"}
        open={openTaskDialog && !!Object.keys(modalData || {})?.length}
        handleOpen={handleModalClose}
        additionalClassContainer={MyTasksCalendarStyles.modalContainer}
        headingContainerAdditionalClass={
          MyTasksCalendarStyles.modalHeadingContainer
        }
      >
        {modalData ? (
          <MyTasksCalendarCard
            data={modalData}
            handleEditTask={handleEditTask}
            handleRescheduleTask={handleRescheduleTask}
            handleMarkAsComplete={handleMarkAsComplete}
            handleDeleteTask={handleDeleteTask}
          />
        ) : (
          <Typography>No Task Details Available</Typography>
        )}
      </ModalComponent>
      <AddTaskForm
        open={isEditTask || isRescheduleTask}
        isUpdate={true}
        handleClose={() =>
          isRescheduleTask ? setIsRescheduleTask(false) : setIsEditTask(false)
        }
        taskName={isRescheduleTask ? "Reschedule Task" : "Edit Task"}
        taskData={modalData || {}}
      />
      {/* Delete Task Confirmation Dialog */}
      <ModalComponent
        heading="Delete Task"
        open={deleteTaskDialogOpen}
        handleOpen={handleDeleteTaskCancel}
        additionalClassContainer={MyTasksCalendarStyles.modalContainer}
        headingContainerAdditionalClass={
          MyTasksCalendarStyles.modalHeadingContainer
        }
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to delete this task? This action cannot be undone.
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", paddingTop:"195px" }}>
            <Button
              variant="outlined"
              onClick={handleDeleteTaskCancel}
              id="cancel-delete-btn"
              data-test-id="test-cancel-delete-btn"
              aria-label="Cancel Delete Task"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDeleteTaskConfirm}
              id="confirm-delete-btn"
              data-test-id="test-confirm-delete-btn"
              aria-label="Confirm Delete Task"
            >
              Delete
            </Button>
          </Box>
        </Box>
      </ModalComponent>
    </>
  );
};

export default MyTasks;
